export const messageTimeTraking = {
    showingFutureState: "Mostrando estados futuros",
    toShowFutureState: "Mostrar estados futuros",
};
